import { ActionLink, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { toggleChangeListActive } from '../../actions/chatList';
import { EInternetStatus } from '../../actions/internetStatus';
import { chatListSelector, internetStatusSelector, userSelector } from '../../selectors';
import { ERequestApiStatus } from '../../types/appState';
import { EDeviceType } from '../../types/deviceType';
import { ERoute } from '../../types/route';
import { ETopMenuStatus } from '../../types/topMenuStatus';
import { trackChangeListClick } from '../TopMenuContainer/tracking';

export const ChangeListButtonContainer: React.FC = () => {
  const dispatch = useDispatch();

  const { chats, currentRoute, isChangeListActive, selectedChats, status, movedToArchiveChatIds, movedToSpamChatIds } =
    useSelector(chatListSelector);
  const internetStatus = useSelector(internetStatusSelector);
  const deviceType = useDeviceType();
  const isMobile = deviceType !== EDeviceType.Desktop;
  const { isAuthenticated } = useSelector(userSelector);

  // TODO проверить актуальность
  const chatsToDisplay = React.useMemo(() => {
    /**
     * Если находимся на странице активных чатов,
     * заблокированные чаты (в спаме) или архивные чаты
     * или чаты которые только что перенесли в спам или архив - не выводим
     */
    if (currentRoute === 'messages') {
      return chats.filter(
        chat =>
          !chat.blocked &&
          !chat.archived &&
          !movedToSpamChatIds.includes(chat.chatId as string) &&
          !movedToArchiveChatIds.includes(chat.chatId as string),
      );
    }

    return chats;
  }, [currentRoute, chats, movedToSpamChatIds, movedToArchiveChatIds]);
  const isChangeListVisible = React.useMemo(() => {
    return Boolean(chatsToDisplay.length && currentRoute !== ERoute.Spam && isAuthenticated);
  }, [chatsToDisplay.length, currentRoute, isAuthenticated]);

  const onChangeListClick = React.useCallback(() => {
    dispatch(toggleChangeListActive());

    if (!isChangeListActive) {
      trackChangeListClick();
    }
  }, [dispatch, isChangeListActive]);

  const topMenuStatus =
    internetStatus === EInternetStatus.Offline
      ? ETopMenuStatus.Offline
      : !isAuthenticated
        ? ETopMenuStatus.NotAuthorized
        : status === ERequestApiStatus.Pending
          ? ETopMenuStatus.Loading
          : isChangeListActive
            ? ETopMenuStatus.ChangeList
            : ETopMenuStatus.Default;

  return isChangeListVisible ? (
    <ActionLink
      data-name="ChangeListButtonContainer"
      onClick={onChangeListClick}
      disabled={topMenuStatus === ETopMenuStatus.Loading}
      fontWeight={isMobile ? 'bold' : 'normal'}
      fontSize={isMobile ? 'M' : 'S'}
    >
      {selectedChats.length > 0
        ? `Сбросить ${selectedChats.length}`
        : [ETopMenuStatus.ChangeList].includes(topMenuStatus)
          ? 'Сбросить'
          : 'Выбрать'}
    </ActionLink>
  ) : null;
};
